import { BaseImageSettings } from '../../hooks/useImageSettings';

export const RECOMMENDED_PRODUCTS_CAROUSEL_COMPONENT_NAME = 'recommended-products-carousel';

export const RECOMMENDED_PRODUCTS_CAROUSEL_IMAGE_VIEWPORT_SETTINGS: BaseImageSettings = {
    xs: 'small',
    sm: 'small',
    md: 'small',
    lg: 'small',
    xl: 'small'
};
